class ApiService {
    // APIPROD
    //static baseUrl = 'http://localhost:8080';
    static baseUrl = 'https://api.armbrustliga.de';

    //  static isAuthenticated = false; // Beispiel für den Authentifizierungsstatus

    static setAuthenticationStatus(status) {
        this.isAuthenticated = status;
    }

    static async fetchListen(request) {
        const url = `${this.baseUrl}/info/${request}`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchDisziplin() {
        const url = `${this.baseUrl}/info/disziplin`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchAltersklassen(disziplin) {
        const url = `${this.baseUrl}/info/altersklassen/disziplin/${disziplin}`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchVerein() {
        const url = `${this.baseUrl}/info/verein`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchVereinByDisziplin(selectedCode) {
        const url = `${this.baseUrl}/info/disziplin/${selectedCode}/verein`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchLigenByDisziplin(diziplinCode) {
        const url = `${this.baseUrl}/info/liga/${diziplinCode}`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchMannschaftenByDisziplin(year, disziplinCode) {
        const url = `${this.baseUrl}/info/disziplin/${disziplinCode}/year/${year}/mannschaften`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchMannschaftenByLiga(year, ligaId) {
        const url = `${this.baseUrl}/info/liga/${ligaId}/year/${year}/mannschaften`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }


    static async fetchMannschaftenByDisziplinAndVerein(selectedDisziplinId, selectedVereinId) {
        const url = `${this.baseUrl}/info/disziplin/${selectedDisziplinId}/verein/${selectedVereinId}/mannschaften`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchPersonsByVerein(token, selectedVereinId, disziplinId = null) {
        let url = `${this.baseUrl}/info/verein/${selectedVereinId}/personen`;
        if (disziplinId !== null && disziplinId !== undefined) {
            url += `?disziplinId=${disziplinId}`;
        }
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchPersonsByMannschaft(token, selectedMannschaftId) {
        const url = `${this.baseUrl}/info/person/${selectedMannschaftId}`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchPaarungen(year, ligaId) {
        const url = `${this.baseUrl}/info/paarungen/${year}/${ligaId}`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchTable(year, ligaId) {
        const url = `${this.baseUrl}/info/table/${year}/${ligaId}`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchResults(year, ligaId) {
        const url = `${this.baseUrl}/info/results/${year}/${ligaId}`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchEinzelwertung(disziplinCode, year, altKlId) {
        const url = `${this.baseUrl}/info/einzelwertung/disziplin/${disziplinCode}/jahr/${year}/klasse/${altKlId}`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async fetchSetzliste(year, mannschaftId) {
        const url = `${this.baseUrl}/info/setzliste/${year}/${mannschaftId}`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async createSaisondaten(token, mannschaftenList, force = false) {
        const url = `${this.baseUrl}/api/update/mannschaften`;
        const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Authorization': `Bearer ${token.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                mannschaftenList,
                force: force
            }),
        });
        if (response.ok) {
            return { success: true };
        }
        if (response.status === 409) {
            const errorData = await response.json();
            if (errorData.error === 'SAISON_UPDATE_CONFIRMATION_REQUIRED') {
                return {
                    success: false,
                    requiresConfirmation: true,
                    message: errorData.message,
                    targetYear: errorData.targetYear,
                    hasExistingData: errorData.hasExistingData || false
                };
            }
        }
        return {
            success: false,
            requiresConfirmation: false,
            message: 'Fehler beim Speichern der Daten'
        };
    }

    static async createVerein(token, verein, verband) {
        const url = `${this.baseUrl}/api/create/verein`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                verein,
                verband
            }),
        });
        return !!(response.ok);
    }

    static async createPerson(token, vorname, nachname, geburtsjahr, geschlecht, vereinId) {
        const url = `${this.baseUrl}/api/create/person`;
        console.log("Token in call: ", token);
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                vorname,
                nachname,
                geburtsjahr,
                geschlecht,
                vereinId
            }),
        });
        return !!(response.ok);
    }

    static async createMannschaft(token, disziplinId, vereinId, mannschaft) {
        const url = `${this.baseUrl}/api/create/mannschaft`;
        const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Authorization': `Bearer ${token.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                disziplinId,
                vereinId,
                mannschaft
            }),
        });
        return !!(response.ok);
    }

    static async createMannschaftsmeldung(token, personId, disziplinId, mannschaftId) {
        const url = `${this.baseUrl}/api/create/mannschaftmeldung/${personId}`;
        const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Authorization': `Bearer ${token.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                disziplinId: disziplinId,
                mannschaftId: mannschaftId
            }),
        });
        return !!(response.ok);
    }

    static async deleteMannschaftsmeldung(token, personId, disziplinId, mannschaftId) {
        const url = `${this.baseUrl}/api/delete/mannschaftmeldung/${personId}`;
        const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Authorization': `Bearer ${token.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                disziplinId: disziplinId,
                mannschaftId: mannschaftId
            }),
        });
        return !!(response.ok);
    }

    static async createWettkampf(token, ligaId, paarungen) {
        const url = `${this.baseUrl}/api/create/wettkampf`;
        const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Authorization': `Bearer ${token.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                liga: ligaId,
                paarungen: paarungen.map(durchgang => durchgang.map(pair => ({id_heim: pair[0], id_fern: pair[1]})))
            }),
        });
        return !!(response.ok);
    }

    static async createErgebnisse(token, ergebnisDto) {
        const url = `${this.baseUrl}/api/create/ergebnisse`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(ergebnisDto),
        });
        return !!(response.ok);
    }

    static async fetchLogin(username, password) {
        const url = `${this.baseUrl}/login`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify({
                username, password
            })
        });
        if (!response.ok) {
            throw new Error('Login failed');
        }
        return await response.json();
    }

    static async dAction(token) {
        const url = `${this.baseUrl}/api/update/`;// disabled = `${this.baseUrl}/api/update/d`;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async createUser(token, username, password, mannschaftIds) {
        const url = `${this.baseUrl}/api/create/user`;
        const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Authorization': `Bearer ${token.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username,
                password,
                mannschaftIds: Array.from(mannschaftIds)
            })
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || 'Fehler beim Erstellen des Users');
        }
        return { success: true };
    }

    /* eventuell verbesserung. aber nur für GET ohne Body mit Auth
    static async fetchWithAuth(url, token) {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }
*/
}

export default ApiService;
